




import { Component, Vue } from 'vue-property-decorator';
import unitPaycheckSettingsRequiredGuard from '@/guards/unit-paycheck-settings-required-guard';

@Component({
  beforeRouteEnter: (to, from, next) => {
    unitPaycheckSettingsRequiredGuard(to, from, next);
  },
})
export default class PaycheckReports extends Vue {}
